var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427319699"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9 5.53568C14.8999 3.75265 14.4049 2.07398 13.5567 0.641305C16.7271 2.24192 18.9125 5.49724 18.9125 9.25488C18.9125 14.5764 14.544 18.8861 9.15625 18.8861C5.52088 18.8861 2.36119 16.9319 0.686317 14.0079C2.04288 14.7131 3.59207 15.1236 5.21875 15.1236C10.5806 15.1236 14.9315 10.8399 14.9 5.53568Z",
    fill: "#FFCE31",
    stroke: "#37474F",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.2302 12.55C15.8735 12.55 15.5302 12.6056 15.2063 12.7083C14.8241 11.5817 13.7841 10.7722 12.5579 10.7722C11.2424 10.7722 10.1413 11.7044 9.83628 12.9594C9.51072 12.7061 9.10906 12.5506 8.66906 12.5506C7.59517 12.5506 6.72461 13.4456 6.72461 14.5506C6.72461 14.8189 6.77795 15.0733 6.87128 15.3078C6.68572 15.2539 6.49406 15.2167 6.29239 15.2167C5.09906 15.2167 4.13184 16.2117 4.13184 17.4389C4.13184 18.6661 5.09906 19.6611 6.29239 19.6611H16.2307C18.1396 19.6611 19.6874 18.07 19.6874 16.1056C19.6874 14.1417 18.1396 12.55 16.2302 12.55Z",
    fill: "#E1E8ED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.f7b30395284c658a5b17793b6cf9dc16.svg";
export { ForwardRef as ReactComponent };